module.exports = __webpack_public_path__ + "static/media/YM32_2.582a9688.jpg";